const FOOD_ARTICLE_HFBS = ["60", "61"];

export const isFoodArticleHfb = (hfb?: string | null): boolean =>
  !!hfb && FOOD_ARTICLE_HFBS.includes(hfb.trim());
